export default __webpack_public_path__ + "static/media/envelope.3aa84eac.svg";